import React from "react";
import ReactDOM from "react-dom";

export default function showSuccessToast(message) {
  if (typeof document === "undefined") return;

  const container = document.createElement("div");
  document.body.appendChild(container);

  let isClosed = false;

  const handleClose = () => {
    if (isClosed) return;

    isClosed = true;
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  };

  ReactDOM.render(
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: 9999,
        minWidth: "300px",
        maxWidth: "420px",
        padding: "14px 18px",
        borderRadius: "8px",
        background: "#43ba94",
        color: "#fff",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
      }}
    >
      {message}
    </div>,
    container,
  );

  setTimeout(() => {
    handleClose();
  }, 4000);
}